import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import SearchBox from './SearchBox';

const navItems = [
  { to: '/', label: '首页', icon: 'ri-home-4-line' },
  { to: '/category', label: '电影分类', icon: 'ri-film-line' },
  { to: '/special', label: '影评专题', icon: 'ri-book-marked-line' },
  { to: '/news', label: '资讯', icon: 'ri-newspaper-line' },
  { to: '/about', label: '关于我们', icon: 'ri-information-line' },
];

export default function SiteHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);

  return (
    <header className="sticky top-0 z-40 w-full bg-background-50/95 backdrop-blur border-b border-background-200/80">
      <div className="h-1 w-full bg-primary-500" />
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center gap-3 md:gap-6 h-16 md:h-[68px]">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-xl" aria-hidden="true" />
            </span>
            <span className="leading-tight">
              <span className="block font-heading text-lg font-extrabold tracking-tight text-foreground-950 whitespace-nowrap">
                韩国理论片
              </span>
              <span className="hidden sm:block font-label text-[10px] uppercase tracking-[0.22em] text-foreground-500">
                Korean Cinema Review
              </span>
            </span>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-1 ml-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `px-3 h-9 flex items-center rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* Desktop search */}
          <div className="hidden md:block flex-1 max-w-md ml-auto">
            <SearchBox variant="header" />
          </div>

          {/* Mobile actions */}
          <div className="flex items-center gap-2 ml-auto md:hidden">
            <button
              type="button"
              onClick={() => setMobileOpen((v) => !v)}
              className="w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
              aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
            >
              <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile panel */}
      {mobileOpen && (
        <div className="md:hidden absolute left-0 right-0 top-full h-[calc(100vh-68px)] bg-background-50 border-t border-background-200 overflow-y-auto">
          <div className="px-4 py-4">
            <SearchBox variant="panel" onNavigate={() => setMobileOpen(false)} />
            <nav className="mt-4 flex flex-col gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === '/'}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-3 h-12 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                      isActive
                        ? 'bg-primary-50 text-primary-700'
                        : 'text-foreground-800 hover:bg-background-100'
                    }`
                  }
                >
                  <i className={`${item.icon} text-lg text-foreground-500`} aria-hidden="true" />
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}